import * as angular from "angular";
import {IController, IScope, ITimeoutService, IWindowService} from "angular";
import * as _ from "lodash";
import {DateRangeTemplateType} from "../../../commons/types/date-range-template.type";
import {ViewSettingsModel} from "../../../commons/models/view-settings.model";
import {SiteFiltersType} from "../../../commons/types/site-filters.type";
import {SplitService} from "../../../commons/services/split-service.service";
import {QuickFilterContextService} from "../../../commons/services/quick-filter-context.service";
import {ViewFilterSettingsService} from "../../../commons/services/view-filter-settings.service";
import {BranchesDialogService} from "../../../branches/services/branches-dialogs-service.service";
import {DeliveriesDialogService} from "../../../deliveries/services/deliveries-dialog-service.service";
import {DeliveriesService} from "../../../deliveries/services/deliveries-service.service";
import {ServicesService} from "../../../deliveries/services/services-service.service";
import {RoutesService} from "../../../routes/services/routes-service.service";
import {OmsService} from "../../../oms/services/oms-service.service";
import {LeanPlanningDialogService} from "../../services/lean-planning-dialogs-service.factory";
import {LeanPlanningService} from "../../services/lean-planning-service.service";
import {LeanPlanningRequestsService} from "../../services/plan-requests.factory";
import {CommonsDialogService} from "../../../commons/services/commons-dialog.service";
import {CommonsService} from "../../../commons/services/commons-service.service";
import {ConfirmDialogService} from "../../../commons/services/confirm-dialog.service";
import {DateRangeTimeFiltersService} from "../../../commons/services/date-range-time-filters.service";
import {ExportType} from "../../../commons/types/export.type";
import {RouteExportRowType} from "../../../routes/enums/route-export-row.type";
import {
  ResourceAllocationTimeWindowExtModel
} from "../../../resources/models/resource-allocation-time-window-ext.model";
import {ChangeRouteResourceQueryModelModel} from "../../../routes/models/change-route-resource-query-model.model";

export class planningDispatchRoutesViewCtrl implements IController {
  from: any;
  to: any;
  branchIds: any;
  agentIds: any;
  agentSkills: string[];
  serviceAreaIds: any;
  status: any;
  selectedQuickFilterId: string;
  dateRangeTemplateType?: DateRangeTemplateType;

  public pageName: string;
  private siteId: any;
  private canEdit: boolean;
  // private actionsByStatus: any;
  private routeActionToTitle: any;
  private showMap: boolean;
  private routes: any;
  private totals: any;
  private routesRefList: any;
  private filterConfig: any;
  private size: any;
  private page: any;

  private paginationPages: any;
  private routesServiceAreas: any;
  private serviceAreasRef: any;
  private selectedRouteIds: any;
  private hiddenRouteIds: any;
  private omsOrderRef: any;

  constructor(private leanPlanningService: LeanPlanningService, private leanPlanningDialogService: LeanPlanningDialogService,
              private $planningRoutes, private deliveriesService: DeliveriesService, private routesService: RoutesService, private TimelineService,
              private leanPlanningRequestsService: LeanPlanningRequestsService, private IAMPermissions, private $timeout: ITimeoutService, private branchesDialogService: BranchesDialogService,
              private $log, private confirmDialogService: ConfirmDialogService, private leanPlanningConstants, private commonsDialogService: CommonsDialogService,
              private $window: IWindowService, private $scope: IScope, private servicesService: ServicesService, private deliveriesDialogService: DeliveriesDialogService,
              private splitService: SplitService, private dateRangeTimeFiltersService: DateRangeTimeFiltersService, private $state, private quickFilterContextService: QuickFilterContextService,
              private $serviceArea, private $omsOrder, private omsService: OmsService, private viewFilterSettingsService : ViewFilterSettingsService, private commonsService: CommonsService) {
    this.pageName = this.$state.current.name;
    this.serviceAreasRef = this.$serviceArea();
  }

  $onInit() {
    this.siteId = this.splitService.getSiteId();
    this.canEdit = this.IAMPermissions.hasPermission('planning.routes.update');

    this.routeActionToTitle = {
      handleUnpacked: 'Handle Unpacked Deliveries',
      assign: 'Assign And Select Driver',
      reOptimize: 'Re Optimize Route',
      editRoute: false,
      resetRoute: 'Reset Route',
      removeRoute: 'Remove Route',
      removeTask: false,
      printRoute: 'Print',
      updateResource: 'Update Resource',
      printLoadingSheet: 'Print Loading Sheet',
      printBillOfLading: 'Print Bill Of Lading',
      downloadBillOfLading: 'Download Bill Of Lading'
    };
    this.showMap = false;
    this.routesServiceAreas = [];
    this.selectedRouteIds = [];
    this.hiddenRouteIds = [];
    this.filterConfig = {
      customTemplates: this.dateRangeTimeFiltersService.getDeliveriesCustomTemplates(),
      queryString: undefined,
      range: this.dateRangeTemplateType ? this.dateRangeTimeFiltersService.getDateRangeFilterByType(this.dateRangeTemplateType) :
        ((this.from && this.to) ? {dateStart: this.from, dateEnd: this.to} : this.dateRangeTimeFiltersService.today()),
      status: this.status || 'All',
      includeFilters: [
        SiteFiltersType.dateRangeTemplateType,
        SiteFiltersType.branchIds,
        SiteFiltersType.serviceAreaIds,
        SiteFiltersType.agentIds,
        SiteFiltersType.agentSkills
      ],
      bringozFilters: {
        [SiteFiltersType.dateRangeTemplateType]: this.dateRangeTemplateType,
        [SiteFiltersType.branchIds]: this.branchIds || [],
        [SiteFiltersType.serviceAreaIds]: this.serviceAreaIds || [],
        [SiteFiltersType.agentIds]: this.agentIds || [],
        [SiteFiltersType.agentSkills]: this.agentSkills || []
      }
    }

    this.routes = undefined; // Loading On when undefined
    this.routesRefList = [];

    this.size = 10;
    this.page = 0;

    this._initRoutes();
    this._setTotals();

    this.omsOrderRef = this.$omsOrder();
  };

  $onChanges(changes) {
    if ((changes.branchIds && !changes.branchIds.isFirstChange()) ||
      (changes.serviceAreaIds && !changes.serviceAreaIds.isFirstChange()) ||
      (changes.agentSkills && !changes.agentSkills.isFirstChange()) ||
      (changes.agentIds && !changes.agentIds.isFirstChange())) {

      this.filterConfig.bringozFilters = {
        status: this.filterConfig.status,
        branchIds: this.branchIds || [],
        serviceAreaIds: this.serviceAreaIds || [],
        agentIds: this.agentIds || [],
        agentSkills: this.agentSkills || []
      }

      this._initRoutes();
    }
  };

  $onDestroy() {
    if (this.routesRefList.length) {
      this._destroyRoutesBindings();
    }
  };

  // ******************************
  //        Public methods
  // ******************************

  changeStatus(status) {
    this.filterConfig.status = status;
    this._initRoutes();
    this._setTotals();
    this._setStateParams();
    // this._setTotals();
  }

  submitQuery(queryString) {
    this.filterConfig.queryString = queryString;
    this._initRoutes();
  }

  onRangeChanged(range) {
    this.filterConfig.range = range;

    if (this.selectedQuickFilterId && range?.type !== this.filterConfig.bringozFilters.dateRangeTemplateType) {
      this.selectedQuickFilterId = undefined;
    }

    this.filterConfig.bringozFilters.dateRangeTemplateType = this.dateRangeTimeFiltersService.getDateRangeFilterByType(range.type)?.type;
    this._initRoutes();
    this._setTotals();
    this._setStateParams();
  }

  onQuickFilterSelect(quickFilter: ViewSettingsModel) {
    if (!!quickFilter) {
      this.onFiltersChange(quickFilter?.settings, quickFilter);
    } else {
      const filters = angular.copy(this.filterConfig.bringozFilters);
      _.forOwn(filters, (value, key) => {
        filters[key] = _.isArray(value) ? [] : undefined;
      })
      this.onFiltersChange(filters);
    }
  }

  onFiltersChange(filters, selectedQuickFilter?) {
    this.selectedQuickFilterId = selectedQuickFilter?.id;
    this.viewFilterSettingsService.setActiveQuickFilter(selectedQuickFilter, this.pageName);
    this.filterConfig.bringozFilters = filters;

    if (!!filters.dateRangeTemplateType) {
      this.filterConfig.range = this.dateRangeTimeFiltersService.getDateRangeFilterByType(filters.dateRangeTemplateType);
    }

    this._initRoutes();
    this._setTotals();
    this._setStateParams();
  }

  isPaginationItemSelected(pageIndex) {
    return _.get(this.routes, 'pageable.pageNumber') === pageIndex;
  }

  onPaginationBrowse(isNext) {
    this.page = isNext ? (this.page + 1) : (this.page - 1);
    this._initRoutes();
  }

  onPaginationChange(pageIndex) {
    this.page = pageIndex;
    this._initRoutes();
  }

  onShowTaskTooltip(task, $event) {

  }

  // private _setDisplayedServiceAreas() {
  //   const displayedRoutes = _.filter(this.routes.content, (r) => {
  //     return !_.includes(this.hiddenRouteIds, r.id)
  //   })
  //   const routesServiceAreas = _.flatMap(displayedRoutes, (r) => {
  //     return r.serviceAreaList
  //   })
  //   this.routesServiceAreas = _.uniqBy(routesServiceAreas, 'areaId');
  // }


  private _setDisplayedServiceAreas() {
    const displayedRoutes = _.filter(this.routes.content, (r) => {
      return !_.includes(this.hiddenRouteIds, r.id)
    })
    const routesServiceAreaIds = _.uniq(_.flatMap(displayedRoutes, (r) => {
      return r.serviceAreaIdList
    }))

    this.serviceAreasRef.$asyncValues(routesServiceAreaIds)
      .then((serviceAreas) => {
        this.routesServiceAreas = serviceAreas;
      })
      .catch((error) => {
        if (error) {
          this.$log.error('Error while getting service areas from server, siteMarket Map \n' + error)
        }
      });
  }

  // onToggleShowRoute(routeId) {
  //   const hiddenRouteIndex = _.findIndex(this.hiddenRouteIds, (id) => {
  //     return id === routeId;
  //   })
  //   const hiddenRouteIdsCopy = angular.copy(this.hiddenRouteIds);
  //
  //   if (hiddenRouteIndex > -1) {
  //     hiddenRouteIdsCopy.splice(hiddenRouteIndex, 1);
  //   } else {
  //     hiddenRouteIdsCopy.push(routeId)
  //   }
  //
  //   this.hiddenRouteIds = hiddenRouteIdsCopy;
  //   this._setDisplayedServiceAreas();
  // }

  onToggleBlockRoute(routeId, isBlockedByUser) {
    this.leanPlanningService.editBlockedState(routeId, !isBlockedByUser)
      .then((updatedRoute) => {
        this.routes.content = _.uniqBy(_.concat([updatedRoute], this.routes.content), 'id');
        // if (expandedRouteIndex > -1) {
        //   const expandedRoutesCopy = angular.copy(this.expandedRoutes);
        //   expandedRoutesCopy[expandedRouteIndex] = updatedRoute;
        //
        //   this.expandedRoutes = expandedRoutesCopy;
        //   this.expandedRoutesTasks = _.uniqBy(_.concat(updatedRoute.taskListExt, this.expandedRoutesTasks), 'id');
        // }
      })
  }

  onToggleSelectRoute(routeId) {
    const selectedRouteIndex = _.findIndex(this.selectedRouteIds, (id) => {
      return id === routeId;
    })
    const selectedRouteIdsCopy = angular.copy(this.selectedRouteIds);

    if (selectedRouteIndex > -1) {
      selectedRouteIdsCopy.splice(selectedRouteIndex, 1);
    } else {
      selectedRouteIdsCopy.push(routeId)
    }

    this.selectedRouteIds = selectedRouteIdsCopy;
  }

  onToggleRouteDisplay(id, isEnabled) {
    if (isEnabled) {
      this.hiddenRouteIds = _.filter(this.hiddenRouteIds, function (rid) {
        return rid !== id;
      })
    } else {
      this.hiddenRouteIds = this.hiddenRouteIds.concat([id]);
    }
  }

  openRouteInNewWindow(routeId) {
    const url = this.$state.href('planning-route', {id: routeId});
    this.$window.open(url, '_blank');
  }

  goToAgent(agentId) {
    this.$state.go('agent.itinerary', {id: agentId});
  }

  onMoveTask(serviceIds, fromRouteId, toRouteId, fromOrderedIds, toOrderedIds, assignServices, resetServices) {
    var payload = this.TimelineService.getMovedTaskPayload(serviceIds, fromRouteId, toRouteId, fromOrderedIds, toOrderedIds);

    this.leanPlanningRequestsService.editRoutes(payload, assignServices, resetServices)
      .then((updatedRoutes) => {
        var routesCopy = angular.copy(this.routes.content);
        _.forEach(updatedRoutes, (r) => {
          var routeIndex = _.findIndex(this.routes.content, (route: any) => {
            return r.id === route.id;
          })
          if (routeIndex > -1) {
            routesCopy[routeIndex] = r;
          }
        })
        this.routes.content = routesCopy;
      })
  }

  onRouteActionSelect(route, event) {
    const activeActionsMap = this.leanPlanningService.getRoutesActionsMap([route]);

    const activeActions = [];
    _.forOwn(activeActionsMap, (value, key) => {
      if (!!value && !!this.routeActionToTitle[key]) {
        activeActions.push(this.routeActionToTitle[key])
      }
    })

    this.commonsService.openActionPanel(activeActions, event)
      .then((reason) => {
        if (_.isEqual(reason, 'Handle Unpacked Deliveries')) {
          this._onHandleUnpackedDeliveries(route, event);
        } else if (_.isEqual(reason, 'Assign And Select Driver')) {
          this._onAssignRouteAndSelectDriver(route.id, event);
        } else if (_.isEqual(reason, 'Re Optimize Route')) {
          this._onReoptimizedRoute(route.id);
        } else if (_.isEqual(reason, 'Reset Route')) {
          this.onResetRoutes([route.id]);
        } else if (_.isEqual(reason, 'Remove Route')) {
          this.onDeleteRoutes([route.id]);
        } else if (_.isEqual(reason, 'Update Resource')) {
          this.onUpdateResource(route);
        } else if (_.isEqual(reason, 'Print')) {
          this.routesService.printRoutes([route.id]);
        } else if (_.isEqual(reason, 'Print Loading Sheet')) {
          this.routesService.printLoadingSheet([route.id]);
        } else if (_.isEqual(reason, 'Print Bill Of Lading')) {
          this.routesService.onPrintBOL([route.id]);
        } else if (_.isEqual(reason, 'Download Bill Of Lading')) {
          this.routesService.onDownloadBOL([route.id]);
        }
      })
  }

  onViewServices(ids) {
    if (!ids) {
      return;
    }
    this.servicesService.getServices(ids)
      .then((services) => {
        if (services.length > 1) {
          this.deliveriesDialogService.servicesInfo(services);
        } else {
          this.deliveriesDialogService.serviceInfo(services[0]);
        }
      })
  }

  onAssignRoutesToAttachedAgent(ids) {
    this.routesService.assignRoutesToAttachedAgents(
      ids,
      this.filterConfig.bringozFilters.branchIds,
      [],
      this.filterConfig.range.dateStart,
      this.filterConfig.range.dateEnd,
      this.filterConfig.bringozFilters.agentSkills,
    ).then(() => {
      this.selectedRouteIds = [];
      this._initRoutes(true);
      this._setTotals(true);
    })
  }

  onMergeRoutes(ids) {
    this.routesService.mergeRoutes(
      ids,
      this.filterConfig.bringozFilters.branchIds,
      [],
      this.filterConfig.range.dateStart,
      this.filterConfig.range.dateEnd,
      this.filterConfig.bringozFilters.agentSkills,
    ).then(() => {
      this.selectedRouteIds = [];
      this._initRoutes(true);
      this._setTotals(true);
    })
  }

  onResetRoutes(ids) {
    this.confirmDialogService.confirm('Reset Routes', 'Are you sure you want to reset?')
      .then(() => {
        this._resetRoutes(ids);
      })
      .catch(() => {
        this.$log.info('Dialog Closed');
      })
  }

  onDeleteRoutes(ids) {
    var title = ids && ids.length > 1 ? 'Delete Routes' : 'Delete Route';
    this.confirmDialogService.confirm(title, 'Are you sure you want to delete?')
      .then(() => {
        this._deleteRoutes(ids);
      })
      .catch(() => {
        this.$log.info('Dialog Closed');
      })
  }

  onUpdateResource(route) {
    this.leanPlanningDialogService.updateResource(route)
      .then((payload: {
        allocation: ResourceAllocationTimeWindowExtModel,
        queries: ChangeRouteResourceQueryModelModel
      }) => {
        this._reCreateRoute(route, payload.allocation, payload.queries);
      })
      .catch((error) => {
        this.$log.info('Dialog Closed', error)
      })
  }

  onUpdateBranchesRoutes(ids, event) {
    this.branchesDialogService.branchesSelect(event)
      .then((branchIds) => {
        this._updateBranchesRoutes(ids, branchIds);
      })
  }

  onExport(ids, event, type: RouteExportRowType) {
    this.routesService.exportRoutes(
      ids,
      undefined,
      this.filterConfig.bringozFilters.branchIds,
      this.filterConfig.bringozFilters.serviceAreaIds,
      this.filterConfig.status === 'All' ? undefined : [this.filterConfig.status],
      this.filterConfig.range.dateStart,
      this.filterConfig.range.dateEnd,
      this.filterConfig.queryString,
      this.filterConfig.bringozFilters.agentSkills,
      type)
      .then((res) => {

      });
  }


  // ******************************
  //        Private methods
  // ******************************

  private _onHandleUnpackedDeliveries(route, event) {
    var unpackedDeliveries = [];
    _.forEach(route.serviceList, (service) => {
      const isUnpacked = this.deliveriesService.isDeliveryUnpacked(service.packageList[0].items);
      if (isUnpacked) {
        unpackedDeliveries.push(service);
      }
    });
    this.leanPlanningDialogService.handleUnpackedServices(unpackedDeliveries, event)
      .then((serviceIdsToRemove) => {
        this._removeServicesFromRoute(route.id, serviceIdsToRemove);
      })
      .catch(() => {
        this.$log.info('Dialog Closed');
      })
  }

  private _onAssignRouteAndSelectDriver(rid, event) {
    this.leanPlanningDialogService.manualAssignRoute(event, rid)
      .then((payload) => {
        this._assignAgentToRoute(rid, payload.agentId, payload.assignServices);
      })
      .catch(() => {
        this.$log.info('Dialog Closed');
      })
  }

  private _assignAgentToRoute(rid, agentId, assignServices) {
    this.leanPlanningRequestsService.assignRouteToAgent(rid, agentId, assignServices)
      .then(() => {
        this._initRoutes(true);
        this._setTotals(true);
      })
      .catch((error) => {
        this.$log.error('Failed to assign route to driver @planningRoutesTable@onAssignRoute', error);
      })
  }

  private _onReoptimizedRoute(routeId) {
    this.leanPlanningService.optimizeRoute(routeId)
      .then((optimizedRoute: any) => {
        var routeIndex = _.findIndex(this.routes.content, (route: any) => {
          return optimizedRoute.id === route.id;
        })
        if (routeIndex > -1) {
          var routesCopy = angular.copy(this.routes.content);
          routesCopy[routeIndex] = optimizedRoute;
          this.routes.content = routesCopy;
        }
      })
  }

  private _removeServicesFromRoute(rid, serviceIdsToRemove) {
    this.leanPlanningService.removeDeliveryFromRoute(serviceIdsToRemove, rid)
      .then(() => {
        this._initRoutes(true);
        this._setTotals(true);
      })
  }

  private _resetRoutes(ids) {
    this.routesService.resetRoutes(ids,
      this.filterConfig.bringozFilters.branchIds,
      [],
      this.filterConfig.range.dateStart,
      this.filterConfig.range.dateEnd,
      this.filterConfig.bringozFilters.agentSkills,
    ).then((updatedRoutes) => {
      this.selectedRouteIds = [];
      // this._initRoutes();
      // this._setTotals();
    })
  }

  private _deleteRoutes(ids) {
    this.routesService.deleteRoutes(
      ids,
      this.filterConfig.bringozFilters.branchIds,
      [],
      this.filterConfig.range.dateStart,
      this.filterConfig.range.dateEnd,
      this.filterConfig.bringozFilters.agentSkills,
    ).then(() => {
      this.selectedRouteIds = [];
      this.routes.content = _.filter(this.routes.content, (route) => {
        return !_.includes(ids, route.id)
      });
    })
  }

  private _setTotals(addTimeOut?) {
    this.totals = undefined;
    var timeoutLength = addTimeOut ? 3000 : 0;
    this.$timeout(timeoutLength).then(() => {
      this.routesService.getRoutesStatusesTotals(
        undefined,
        this.filterConfig.range.dateStart,
        this.filterConfig.range.dateEnd,
        this.filterConfig.bringozFilters.branchIds,
        this.filterConfig.bringozFilters.serviceAreaIds,
        this.filterConfig.queryString,
        undefined,
        undefined,
        this.filterConfig.bringozFilters.agentSkills,
      ).then((totals) => {
        this.totals = totals;

        // ctrl.totalSelectedRoutesCount = !!ctrl.filterConfig.statuses.length ?  _.reduce(ctrl.filterConfig.statuses, function(sum, n) {
        //   return sum + (ctrl.totals[n.toLowerCase()] || 0);
        // }, 0) : ctrl.totals.total;
      })
    })
  }

  private _initRoutes(addTimeOut?) {
    const queryPayload = {
      query: this.filterConfig.queryString,
      from: this.filterConfig.range.dateStart,
      to: this.filterConfig.range.dateEnd,
      status: this.filterConfig.status === 'All' ? undefined : this.filterConfig.status,
      branchIds: this.filterConfig.bringozFilters.branchIds,
      areaIds: this.filterConfig.bringozFilters.serviceAreaIds,
      skill: this.filterConfig.bringozFilters.agentSkills,
      // sortByLoad : true,
      size: this.size,
      page: this.page
    };

    this.routes = [];
    this.selectedRouteIds = [];
    this.hiddenRouteIds = [];
    this.paginationPages = undefined;

    this.leanPlanningService.getPageableRoutes(queryPayload, addTimeOut)
      .then((routes: any) => {
        this.routes = routes;
        this.hiddenRouteIds = _.map(routes.content, 'id');
        this.paginationPages = _.range(routes.totalPages);

        this._setDisplayedServiceAreas();

        // this._setServiceAreaIds(routes.content);
        this._bindRoutes(routes.content);
      })
  }

  private _bindRoutes(routes) {

    if (this.routesRefList.length) {
      this._destroyRoutesBindings();
    }

    this.routesRefList = [];

    if (routes && routes.length) {
      const routeIds = _.map(routes, 'id');

      _.forEach(routeIds, (id) => {
        const routeRef = this.$planningRoutes(id);
        this.routesRefList.push(routeRef);

        routeRef.$bindCtrl(this.$scope, this, id);
        routeRef.$registerOnUpdateHandler(this, (updatedRoute) => {

          if (_.isEqual(updatedRoute.id, id)) {
            const routeIndexToUpdate = _.findIndex(this.routes.content, (i: any) => {
              return i.id === updatedRoute.id;
            });
            if (routeIndexToUpdate > -1) {
              let routeToUpdateRef = this.routes.content[routeIndexToUpdate];

              if (updatedRoute.updatedAt > routeToUpdateRef.updatedAt) {
                let routesCopy = angular.copy(this.routes.content);
                updatedRoute.taskListExt = routeToUpdateRef.taskListExt; // TODO REMOVE ITS A WORK A ROUND FOR NO TASKS
                routesCopy[routeIndexToUpdate] = updatedRoute;

                this.routes.content = routesCopy;
              }

            } else {
              // locationRef.$destroy();
            }
          }

        });
      })

    }
  }

  private _destroyRoutesBindings() {
    _.forEach(this.routesRefList, (routeObjectRef) => {
      routeObjectRef.$destroy();
    });
  }

  private _setStateParams() {
    this.$state.go('.', {
      from: this.filterConfig.range.dateStart,
      to: this.filterConfig.range.dateEnd,
      branchIds: this.filterConfig.bringozFilters.branchIds,
      serviceAreaIds: this.filterConfig.bringozFilters.serviceAreaIds,
      agentIds: this.filterConfig.bringozFilters.agentIds,
      agentSkills: this.filterConfig.bringozFilters.agentSkills,
      status: this.filterConfig.status,
      selectedQuickFilterId: this.selectedQuickFilterId,
      dateRangeTemplateType: this.filterConfig.bringozFilters.dateRangeTemplateType
    }, {notify: false, reload: false});
  }

  private _updateBranchesRoutes(selectedIds, branchIdsPayload) {
    this.routesService.updateBranch(
      selectedIds,
      branchIdsPayload,
      this.filterConfig.bringozFilters.branchIds,
      [],
      this.filterConfig.range.dateStart,
      this.filterConfig.range.dateEnd,
      this.filterConfig.bringozFilters.agentSkills
    ).then((updatedRoutes) => {
      this.selectedRouteIds = [];
      // this._initRoutes();
      // this._setTotals();
    })
  }

  private _reCreateRoute(route, resourceAllocation: ResourceAllocationTimeWindowExtModel, queries?: ChangeRouteResourceQueryModelModel) {
    this.leanPlanningService.recreateRoute(route.id, resourceAllocation.resourceAllocationId, resourceAllocation.id, "Allocation", resourceAllocation.id, queries)
  }


}

angular
  .module('bringoz.admin.lean-planning')
  .component('planningDispatchRoutesView', {
    bindings: {
      from: '<?',
      to: '<?',
      branchIds: '<?',
      serviceAreaIds: '<?',
      agentIds: '<?',
      agentSkills: '<?',
      status: '<?',
      selectedQuickFilterId: '<?',
      dateRangeTemplateType: '<?'
    },
    template: require('./planning-dispatch-routes-view.html').default,
    controller: planningDispatchRoutesViewCtrl
  });
